export enum OptimizationSpecialistEventName {
  UserEntersOptimizationSpecialist = 'userEntersOptimizationSpecialist'
}

export type OptimizationSpecialistEvent = {
  name: OptimizationSpecialistEventName.UserEntersOptimizationSpecialist
}
